module.exports = __webpack_public_path__ + "img/down_full.bfbf6ba2.png";